module.exports = __webpack_public_path__ + "img/skybox-picnic.204c5894.svg";